// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3RqQe","label":"LabeledBox_label__1N8Y5"};